import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styled, { ThemeProvider } from 'styled-components';

import { theme } from 'lib/styles';

import {
	FilterContainer,
	FilterName,
	InvisibleToggle,
	FilterOptionsContainer,
} from '../Filters/Filter';
import Icon from 'components/Icon';
import {
	UserAction,
	UserLink,
} from './styles';

import UserContext from 'contexts/User';

const UserToggle = styled(FilterName)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 8px 32px 8px 16px;

	&:hover {
		color: #4A90E2;
	}
`;

const UserIcon = styled(Icon)`
	margin-bottom: 8px;

	${UserToggle}:hover & {
		svg {
			fill: #4A90E2;
		}
	}
`;

class User extends React.Component {
	state = {
	  open: false,
	}

	openHandler = open => this.setState({ open })

	render() {
	  const { t, lng } = this.props;

	  return (
	    <ThemeProvider theme={theme}>
	      <UserContext.Consumer>
	        {data => data === null ? null : (
	          <FilterContainer style={{ minWidth: '100px' }}>
	            <UserToggle
	              onClick={() => this.openHandler(!this.state.open)}
	              open={this.state.open}
	              last={true}
	            >
	              <UserIcon className="icon" icon="user" />
	              <span>{data.firstName} {data.lastName}</span>
	            </UserToggle>
	            <FilterOptionsContainer
	              open={this.state.open}
	              left="auto"
	              right="0px"
	            >
	              {
	                false &&
									<UserLink to={`/${lng}/t/user/`}>
									  <Icon icon="cog" iconclass="right dense" /> {t('header/user/Settings')}
									</UserLink>
	              }

	              <UserAction onClick={this.props.logoutHandler}>
	                <Icon icon="stand-by" iconclass="right dense" /> {t('header/user/Log out')}
	              </UserAction>
	            </FilterOptionsContainer>
	            {
	              this.state.open &&
								<InvisibleToggle onClick={() => this.openHandler(false)} />
	            }
	          </FilterContainer>
	        )}
	      </UserContext.Consumer>
	    </ThemeProvider>
	  )
	}
}

User.propTypes = {
	t: PropTypes.any,
	lng: PropTypes.string,
	history: PropTypes.object,
	userOpenHandler: PropTypes.func,
	logoutHandler: PropTypes.func,
}

export default translate('translations')(User)
